import * as React from 'react';
import {Link as RoutedLink} from 'react-router-dom';

import {EmptyStateSmall} from '../empty-states/empty-state-small';
import {Illustration} from '../illustrations/illustration';
import {Link} from '../link/link';

export type EmptyStateVariant =
    | 'recent-editions'
    | 'draft-editions'
    | 'sent-editions'
    | 'drip-sequences';

type Props = {
    emptyStateVariant: EmptyStateVariant;
};

export function MarketingOutreachSelectListEmptyState(props: Props) {
    let title = 'Send messages from a list';
    let subtitleLinkTo;
    let subtitleLinkText = '';
    let subtitleText;

    switch (props.emptyStateVariant) {
        case 'draft-editions':
        case 'sent-editions':
        case 'recent-editions':
            subtitleLinkTo = '/email-marketing/broadcasts';
            subtitleLinkText = `Create ${
                props.emptyStateVariant === 'sent-editions' ? '& send' : ''
            } a broadcast`;
            subtitleText = 'with all required items to send from here';
            break;
        case 'drip-sequences':
            title = 'Send drips from a list';
            subtitleLinkTo = '/email-marketing/drip-sequences';
            subtitleLinkText = 'Activate a drip sequence';
            subtitleText = 'to send from here';
            break;
    }

    return (
        <EmptyStateSmall
            title={title}
            subtitle={
                <div style={{width: 275}}>
                    {/* @ts-expect-error */}
                    <Link to={subtitleLinkTo} as={RoutedLink} variant='primary'>
                        {subtitleLinkText}
                    </Link>{' '}
                    {subtitleText}
                </div>
            }
            icon={
                <div style={{width: 80, height: 80}}>
                    <Illustration src='cactus-empty-state' width='100%' height='100%' />
                </div>
            }
        />
    );
}
